import { render, staticRenderFns } from "./MultiselectDropdownItems.vue?vue&type=template&id=b40e02f4&scoped=true"
import script from "./MultiselectDropdownItems.vue?vue&type=script&lang=js"
export * from "./MultiselectDropdownItems.vue?vue&type=script&lang=js"
import style0 from "./MultiselectDropdownItems.vue?vue&type=style&index=0&id=b40e02f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e02f4",
  null
  
)

export default component.exports